<template>
  <div class="main-wrapper">
    <Loader :isVisible="isLoading" />
    <div class="btn-add-mobile">
      <Button
        :title="'Add Language'"
        :classType="'primary'"
        :eventFunction="toCreateLanguageHandler"
      />
    </div>
    <div class="flex">
      <div class="left-path">
        <span class="system">
          System Management
        </span>
        <span>
          / Localization
        </span>
      </div>
      <div class="right-path">
        <LiveSearch
          :onSearch="onSearch"
          :maxlength="255"
        />
        <div class="btn-add-full">
          <Button
            :title="'Add Language'"
            :classType="'primary'"
            :eventFunction="toCreateLanguageHandler"
          />
        </div>
      </div>
    </div>
    <div class="accounts-wrapper">
      <div class="ac-wrapper-header">
        <div class="th-name number">
          #
        </div>
        <div class="th-name company">
          <Sorting
            :sortField="`l.${sortedField.name}`"
            :currentSortedField="currentSortedField"
            :handleSortUp="handleSortUp"
            :handleSortDown="handleSortDown"
          />
          language
        </div>
        <div class="th-name company">
          language code
        </div>
        <div class="th-name users-count">
          Enabled for distribution
        </div>
      </div>
      <div
        v-if="!languages.length"
        class="empty-search"
      >
        No Languages to display
      </div>
      <div
        v-for="(item, key) in languages"
        :key="item.id"
        class="account"
        @mouseover="onHoverElem(item)"
        @mouseleave="isHover = false"
      >
        <div class="td number">
          {{ getCurrentNumber(key) }}
        </div>
        <div
          class="td company"
          :title="item.name"
        >
          {{ item.name }}
        </div>
        <div
          class="td company code"
          :title="item.code"
        >
          {{ item.code }}
        </div>
        <div class="td status">
          <div
            class="status-ellipse"
            :style="item.distribution ? {background: '#1fee65'} : {background: '#fb3951'}"
          >
          </div>
          <span v-if="item.distribution">
            Enabled
          </span>
          <span v-else>
            Disabled
          </span>
        </div>
        <div
          v-show="isHover && item.id === selectedId"
          class="icons-wrapper"
        >
          <div
            v-if="!item.distribution"
            :title="'Delete Language'"
          >
            <inline-svg
              :src="iconRemove"
              class="svg-icon remove"
              @click="onOpenModalForRemove(item)"
            >
            </inline-svg>
          </div>
          <div :class="[!item.distribution && 'icon-edit']">
            <router-link
              :to="{ path: `localization/${item.id}` }"
              :title="'Edit Language'"
            >
              <inline-svg
                :src="iconEdit"
                class="svg-icon"
              >
              </inline-svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Pagination
      :action="getPaginationAction"
      :page="pagination.page"
      :totalPages="totalPages"
    />
    <NotificationModal
      ref="modal"
      v-model="isModalOpen"
      :modal="isModalOpen"
      :bodyMessage="bodyMessage"
      :title="modalTitle"
      :onAccept="removeLanguage"
      :onClose="onClose"
    />
    <ErrorModal
      v-model="isModalErrorOpen"
      :modal="isModalErrorOpen"
      :bodyErrorMessage="bodyErrorMessage"
      :onClose="onModalErrorClose"
    />
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
} from 'vuex';
import {
  SET_EDIT_FORM,
  SET_OVERFLOW,
} from '../../store/actions/common';
import {
  GET_LANGUAGES_REQUEST,
  REMOVE_LANGUAGE_REQUEST,
} from '../../store/actions/localization/localizationActions';
import CONFIG from '../../constants/config';

import iconEnabled from '../../assets/icons/icon-enabled-acc.svg';
import iconDisabled from '../../assets/icons/icon-disabled-acc.svg';
import iconRemove from '../../assets/icons/icon-remove-role.svg';

import Pagination from '../../components/common/Pagination.vue';
import Sorting from '../../components/common/Sorting.vue';
import iconEdit from '../../assets/icons/icon-edit-acc.svg';
import LiveSearch from '../../components/common/LiveSearch.vue';
import Button from '../../components/common/Button.vue';
import Loader from '../../components/common/Loader.vue';
import NotificationModal from '../../components/NotificationModal.vue';
import ErrorModal from '../../components/ErrorModal.vue';

export default {
  name: 'LocalizationsList',
  components: {
    NotificationModal,
    Loader,
    Pagination,
    LiveSearch,
    Sorting,
    Button,
    ErrorModal,
  },
  data() {
    const {
      editPerson,
      disablePersonTitle,
      enablePersonTitle,
    } = CONFIG.tooltips;
    return {
      iconEdit,
      iconEnabled,
      iconDisabled,
      iconRemove,
      isModalOpen: false,
      enabledId: null,
      bodyMessage: '',
      modalTitle: '',
      isEnabled: false,
      isHover: false,
      selectedId: null,
      filter: '',
      sortedField: {
        name: 'name',
      },
      currentSortedField: 'l.name',
      currentSortBy: 'ASC',
      isSortedUp: false,
      isSortedDown: false,
      disableTitle: disablePersonTitle,
      enableTitle: enablePersonTitle,
      editPerson,
      isModalErrorOpen: false,
      bodyErrorMessage: '',
      successMessage: CONFIG.successMessages.removedLocalizationMessage,
    };
  },
  computed: {
    ...mapState({
      languages: (state) => state.localization.languages,
      pagination: (state) => state.localization.pagination,
      isLoading: (state) => state.localization.isLoading,
    }),
    ...mapGetters([
      'getCurrentAccountId',
    ]),
    totalPages() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    },
  },
  created() {
    const s = this.$route.name;
    document.title = s[0].toUpperCase() + s.slice(1);

    const params = {
      accountId: this.getCurrentAccountId,
      page: 1,
      filterValue: '',
    };
    this.$store.dispatch(GET_LANGUAGES_REQUEST, params);
  },
  methods: {
    onOpenModalForRemove(item) {
      const {
        deleteLanguageMessage,
      } = CONFIG.modals;
      this.$store.dispatch(SET_OVERFLOW, true);
      this.isRemoveOption = true;
      this.isModalOpen = true;
      this.isEnabled = item.distribution;
      this.enabledId = item.id;
      this.modalTitle = 'Delete Language';
      this.bodyMessage = deleteLanguageMessage;
    },
    onErrorModalOpened() {
      this.isModalErrorOpen = true;
      this.bodyErrorMessage = CONFIG.modals.errorDisabledPerson;
    },
    onModalErrorClose() {
      this.isModalErrorOpen = false;
      this.$store.dispatch(SET_EDIT_FORM, false);
    },
    onOpenModal(person) {
      const {
        disabledPersonMessage,
        enabledPersonMessage,
      } = CONFIG.modals;
      this.$store.dispatch(SET_OVERFLOW, true);
      this.isModalOpen = true;
      this.isEnabled = person.enabled;
      this.enabledId = person.id;
      this.modalTitle = person.enabled ? 'Disable Language' : 'Enable Language';
      this.bodyMessage = person.enabled ? disabledPersonMessage : enabledPersonMessage;
    },
    onClose() {
      this.isModalOpen = false;
      this.$store.dispatch(SET_EDIT_FORM, false);
    },
    toCreateLanguageHandler() {
      this.$router.push('localization/add');
    },
    handleSortUp(field) {
      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
        filterValue: this.filter,
        sortFiled: field,
        sortBy: CONFIG.sort.sortUp,
      };
      this.currentSortedField = params.sortFiled;
      this.currentSortBy = params.sortBy;
      this.$store.dispatch(GET_LANGUAGES_REQUEST, params);
    },
    handleSortDown(field) {
      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
        filterValue: this.filter,
        sortFiled: field,
        sortBy: CONFIG.sort.sortDown,
      };
      this.currentSortedField = params.sortFiled;
      this.currentSortBy = params.sortBy;
      this.$store.dispatch(GET_LANGUAGES_REQUEST, params);
    },
    onSearch(params) {
      this.filter = params.filterValue;
      const getParams = {
        accountId: this.getCurrentAccountId,
        page: params.page,
        filterValue: this.filter,
        sortFiled: this.currentSortedField,
        sortBy: this.currentSortBy,
      };
      this.$store.dispatch(GET_LANGUAGES_REQUEST, getParams);
    },
    getPaginationAction(page) {
      const params = {
        accountId: this.getCurrentAccountId,
        page,
        filterValue: this.filter,
        sortFiled: this.currentSortedField,
        sortBy: this.currentSortBy,
      };
      this.$store.dispatch(GET_LANGUAGES_REQUEST, params);
    },
    onHoverElem(item) {
      this.selectedId = item.id;
      this.isHover = true;
    },
    getCurrentNumber(key) {
      const { pagination } = this;
      return (pagination.page - 1) * pagination.limit + key + 1;
    },
    removeLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        langId: this.enabledId,
      };

      this.$store.dispatch(REMOVE_LANGUAGE_REQUEST, params)
        .then(() => {
          this.$toasted.global.success({
            message: this.successMessage,
          });
          const params = {
            accountId: this.getCurrentAccountId,
            page: localStorage.getItem('localizationPage') || 1,
            filterValue: '',
          };

          this.$store.dispatch(GET_LANGUAGES_REQUEST, params).then((res) => {
            if (!res.data.length) {
              params.page = 1;
              this.$store.dispatch(GET_LANGUAGES_REQUEST, params);
            }
          });
        });
    },
  },
};
</script>

<style scoped>
.flex {
  align-items: center;
  display: flex;
  flex: 0;
  justify-content: space-between;
  margin-bottom: 25px;
  min-height: 40px;
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  padding: 25px 25px 25px 30px;
  width: 100%;
}

.system {
  color: #4c5057;
}

.accounts-wrapper {
  border: 1px solid #43434d;
  height: 100%;
  overflow-y: auto;
}

.ac-wrapper-header {
  background: #282a2e;
  display: flex;
  padding: 13px 0;
}

.th-name {
  align-items: center;
  display: flex;
  font-size: 12px;
  text-transform: uppercase;
}

.td {
  font-size: 14px;
  padding: 15px 0;
  word-break: break-word;
}

.number {
  padding-left: 21px;
  width: 67px;
}

.company {
  padding-left: 20px;
  width: 19%;
}

.users-count {
  padding-left: 20px;
  width: 30%;
}

.status {
  align-items: flex-start;
  display: flex;
  margin-left: 15px;
  width: 10%;
}

.account {
  display: flex;
}

.account:hover {
  background: #383b40;
}

.status-ellipse {
  border-radius: 50%;
  height: 5px;
  margin-right: 6px;
  margin-top: 6px;
  width: 5px;
}

.icons-wrapper {
  align-items: flex-start;
  display: flex;
  flex: 0.95;
  justify-content: flex-end;
  padding-top: 10px;
}

.icon-edit {
  padding-left: 31px;
}

.create-button {
  background: #2591cf;
  color: #fff;
  font-size: 16px;
  letter-spacing: normal;
  padding: 0 16px;
  text-transform: none;
}

.right-path {
  align-items: center;
  display: flex;
}

.empty-search {
  padding-top: 40px;
  text-align: center;
}

.btn-add-mobile {
  display: none;
}

.svg-icon {
  cursor: pointer;
}

.code {
  text-transform: uppercase;
}

@media all and (max-width: 1160px) {
  .users-count {
    width: 20%;
  }
}

@media all and (max-width: 1024px) {
  .btn-add-mobile {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    min-height: 40px;
  }

  .btn-add-full {
    display: none;
  }

  .search-wrapper {
    margin-right: 0;
  }
}
</style>
